module.exports = __webpack_public_path__ + "img/sort-amount-down.ed8b7f27.svg";